export default __webpack_public_path__ + "static/media/fi.5e2e72d2.svg";